import Vue from 'vue'

import uiPagination from './src/ui-pagination.vue';
import uiTableBodyItem from './src/ui-table-body-item.vue';
import uiTableFilter from './src/ui-table-filter.vue';
import uiTableHeaderItem from './src/ui-table-header-item.vue';
import uiTableFooterItem from './src/ui-table-footer-item.vue';
import uiTableHeader from './src/ui-table-header.vue';
import uiTable from './src/ui-table.vue';

var components = [
  uiPagination,
  uiTableBodyItem,
  uiTableFilter,
  uiTableHeaderItem,
  uiTableFooterItem,
  uiTableHeader,
  uiTable
]

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/ui-table/index.js
// module id = 558
// module chunks = 0